const eventCategories = [
  { value: 'interest_rate', label: 'Interest Rate' },
  { value: 'employment', label: 'Employment' },
  { value: 'inflation', label: 'Inflation' },
  { value: 'gdp', label: 'GDP' },
  { value: 'trade_balance', label: 'Trade Balance' },
  { value: 'retail_sales', label: 'Retail Sales' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'housing', label: 'Housing' },
  { value: 'consumer_confidence', label: 'Consumer Confidence' },
  { value: 'central_bank_speech', label: 'Central Bank Speech' },
  { value: 'other', label: 'Other' },
] as const;

export type EconomicEventCategory = (typeof eventCategories)[number]['value'];
export const EVENT_CATEGORIES: ReadonlyArray<{
  value: EconomicEventCategory;
  label: string;
}> = eventCategories;

export interface EconomicEvent {
  id: string;
  event_id?: string;
  eventName: string;
  description?: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  country: string;
  currency?: string;
  timezone: string;
  category: EconomicEventCategory;
  importance: 'low' | 'medium' | 'high';
  actualValue?: string;
  forecastValue?: string;
  previousValue?: string;
  sourceUrl?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Country {
  name: string;
  phoneCode: string;
  currency: string;
  timezone: string[];
}

export const IMPORTANCE_LEVELS = [
  { value: 'all', label: 'All Importance' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];
